module.exports = __webpack_public_path__ + "e3133deaee57016853e65b35192c5c91.png";